const isDev = false
export const BASE_URL = isDev ? 'http://localhost/surveystud/api' : 'https://be.surveystud.com/api';
export const ROOT_URL = isDev ? 'http://localhost/surveystud/' : 'https://be.surveystud.com/';

// Add missing exports for live results functionality
export const API_BASE_URL = isDev ? 'http://localhost/surveystud' : 'https://be.surveystud.com';
export const WS_URL = isDev ? 'ws://localhost:8080' : 'wss://be.surveystud.com:8080';

export const fake = '';
